export default "__VITE_ASSET__BPu_Z56f__"